<div class="flex min-h-dvh flex-col">
  <ui-header title="Hausratversicherung berechnen" [vermitlerLogo]="undefined" [showDefaultLogo]="true" [stepInfo]="stepInfo()" />

  <mat-sidenav-container class="bg-cp-gray-100 flex-1 py-12">
    <div class="page-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-container>

  @if (showNavigator()) {
    <div
      class="fixed right-0 left-0 z-40 flex justify-center pointer-events-none"
      [style.bottom.px]="40"
    >
      <ui-page-navigator class="pointer-events-auto" />
    </div>
  }
</div>
